var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7635 22L12.2712 14.5098C10.6352 15.589 8.65695 16.0227 6.7195 15.727C4.78206 15.4313 3.02327 14.4272 1.78373 12.9092C0.544196 11.3912 -0.0878978 9.46726 0.00985691 7.50996C0.107612 5.55265 0.928259 3.70125 2.31288 2.31428C3.6997 0.929236 5.55122 0.108108 7.50883 0.00993937C9.46645 -0.0882292 11.3908 0.543547 12.9093 1.7829C14.4277 3.02226 15.4322 4.781 15.728 6.71847C16.0239 8.65595 15.5902 10.6343 14.5108 12.2703L22 19.7636L19.7635 22ZM7.90814 3.16294C6.64928 3.16211 5.44165 3.66135 4.55091 4.55085C3.66017 5.44034 3.15929 6.64722 3.15846 7.90599C3.15762 9.16476 3.6569 10.3723 4.54646 11.263C5.43602 12.1537 6.64299 12.6545 7.90185 12.6553C8.52517 12.6557 9.14247 12.5334 9.71851 12.2953C10.2945 12.0571 10.818 11.7079 11.2591 11.2674C11.7001 10.827 12.0501 10.304 12.289 9.72833C12.5279 9.15266 12.6511 8.53556 12.6515 7.91228C12.6519 7.289 12.5296 6.67174 12.2914 6.09575C12.0533 5.51976 11.704 4.99631 11.2635 4.55529C10.8231 4.11428 10.3 3.76433 9.72432 3.52543C9.1486 3.28653 8.53146 3.16335 7.90814 3.16294Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e562ffeb.svg";
export { ForwardRef as ReactComponent };